function getPageTitle() {
	return document.title.substr(0, document.title.indexOf(' | Spork Bytes'));
}

export { getPageTitle };
